import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import {
  getProductImageDisplay,
  type ProductPlaceholderTheme,
} from '@landi/store-core';

/**
 * Product image with periodic-table placeholder fallback for missing/broken URLs.
 *
 * @element landi-product-image
 */
@customElement('landi-product-image')
export class LandiProductImage extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `;

  @property({ type: String, attribute: 'image-url' }) imageUrl = '';
  @property({ type: String, attribute: 'product-name' }) productName = '';
  @property({ type: String, attribute: 'product-sku' }) productSku = '';
  @property({ type: String, attribute: 'product-category' }) productCategory = '';
  @property({ type: String }) alt = '';
  @property({ type: String }) theme: ProductPlaceholderTheme = 'light';
  @property({ type: String }) loading: '' | 'lazy' | 'eager' = 'lazy';
  @property({ type: String, attribute: 'img-class' }) imgClass = '';

  render() {
    const display = getProductImageDisplay({
      url: this.imageUrl,
      name: this.productName,
      sku: this.productSku,
      category: this.productCategory,
      theme: this.theme,
    });

    return html`
      <img
        class=${this.imgClass}
        src=${display.src}
        alt=${this.alt || this.productName}
        loading=${this.loading}
        .onerror=${display.onError}
      />
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'landi-product-image': LandiProductImage;
  }
}
